import { pauseAllMedia } from '@lib/pubsub';
if (!customElements.get('product-model')) {
  customElements.define(
    'product-model',
    class ProductModel extends HTMLElement {
      constructor() {
        super();
        this._isLoading = false;
      }

      connectedCallback() {
        requestAnimationFrame(() => {
          const poster = this.posterElement;
          if (poster) {
            poster.addEventListener('click', this.loadContent.bind(this));
          }
        });
      }

      get posterElement() {
        return this.querySelector('button');
      }

      loadContent() {
        pauseAllMedia();
        if (this.hasAttribute('loaded') || this._isLoading) return;
        this._isLoading = true;
        this.setAttribute('loaded', '');

        this.addEventListener('pointerdown', (e) => e.stopPropagation());
        this.addEventListener('touchstart', (e) => e.stopPropagation());

        const template = this.querySelector('template');
        if (template) {
          const clone = template.content.cloneNode(true);
          this.append(clone);
          
        }

        this.removePoster();

        Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: this.setupModelViewerUI.bind(this),
          },
        ]);
      }

        setupModelViewerUI(errors) {
      if (errors) return;

      const viewer = this.querySelector('model-viewer');
      if (!viewer) return;

      // Initialize ModelViewerUI
      this.modelViewerUI = new Shopify.ModelViewerUI(viewer);

      // Pause all media when model loads or starts interacting
      viewer.addEventListener('load', () => pauseAllMedia(viewer));
      viewer.addEventListener('play', () => pauseAllMedia(viewer));

    
        const controlsOverlay = this.querySelector('.shopify-model-viewer-ui__controls-overlay');
        if (controlsOverlay && !controlsOverlay._pauseHandlerAdded) {
       
          controlsOverlay.addEventListener('click', () => {
            // Pause all other media except the current viewer
            pauseAllMedia(this);
          });
        }
      controlsOverlay._pauseHandlerAdded = true;
    }

      removePoster() {
        const image = this.querySelector('img');
        if (image) {
          image.style.opacity = '0';
          setTimeout(() => image.remove(), 500);
        //  this.toggleButtons(true);
        }
      }

      toggleButtons(isPlaying) {
        const playBtn = this.querySelector('[data-poster-button]');
        const pauseBtn = this.querySelector('[data-pause-button]');
        if (playBtn) playBtn.classList.toggle('hidden', isPlaying);
        if (pauseBtn) pauseBtn.classList.toggle('hidden', !isPlaying);
      }
    }
  );
}
window.ProductModel = {
  loadShopifyXR() {
    Shopify.loadFeatures([
      {
        name: 'shopify-xr',
        version: '1.0',
        onLoad: this.setupShopifyXR.bind(this),
      },
    ]);
  },

  setupShopifyXR(errors) {
    if (errors) return;

    if (!window.ShopifyXR) {
      document.addEventListener('shopify_xr_initialized', () => this.setupShopifyXR());
      return;
    }

    document.querySelectorAll('[id^="ProductJSON-"]').forEach((modelJSON) => {
      window.ShopifyXR.addModels(JSON.parse(modelJSON.textContent));
      modelJSON.remove();
    });
    window.ShopifyXR.setupXRElements();
  },
};

window.addEventListener('DOMContentLoaded', () => {
  if (window.ProductModel) window.ProductModel.loadShopifyXR();
});
